'use strict';

var xhr = require('./utils/xhr.cjs');

function beforeBreadcrumb(breadcrumb, hint) {
  if (isXhrBreadcrumb(breadcrumb) && isXhrHint(hint)) {
    xhr.enrichXhrBreadcrumb(breadcrumb, hint);
  }
  return breadcrumb;
}
function isXhrBreadcrumb(breadcrumb) {
  return breadcrumb.category === "xhr";
}
const isXhrHint = (hint) => {
  return hint?.xhr instanceof XMLHttpRequest;
};

exports.beforeBreadcrumb = beforeBreadcrumb;
//# sourceMappingURL=beforeBreadcrumb.cjs.map
